<template>
  <div>
    <div
      class="h5 flex items-center overflow-hidden bg-near-white featured-container"
    >
      <div class="container pax20 w-100">
        <h1 class="f2-l">{{ $t('news.heading') }}</h1>
        <p>{{ $t('news.subheading') }}</p>
      </div>
    </div>
    <div
      v-for="(chunk, chunkIndex) in posts"
      :key="chunkIndex"
      class="container pa4"
    >
      <div
        v-for="(post, index) in chunk.slice(0, 1)"
        :key="index"
        class="first-line mb4"
      >
        <nuxt-link
          :to="localePath({ name: 'news-slug', params: { slug: post.slug } })"
          class="flex-l db no-underline link black shadow-1 h-100"
        >
          <div class="w-two-thirds-l">
            <img :data-src="post.image" class="post-image lazyload" />
          </div>
          <div class="w-third-l tl pa4">
            <p>{{ post.category }}</p>
            <h2>{{ post.title }}</h2>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="htmlFromMd(post.short)"></div>
            <!-- <p v-for="city in post.cities" :key="city" class="dib ml2">
              {{ city }}
            </p> -->
          </div>
        </nuxt-link>
      </div>
      <div class="second-line flex mb4">
        <div
          v-for="(post, index) in chunk.slice(1, 3)"
          :key="index"
          :class="{ mr4: index !== 1 }"
          class="w-50 ba b--light-silver"
        >
          <nuxt-link
            :to="localePath({ name: 'news-slug', params: { slug: post.slug } })"
            class="no-underline"
          >
            <div class="">
              <img :data-src="post.image" class="lazyload" />
            </div>
            <div class="tl pa4">
              <h3>{{ post.title }}</h3>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div v-html="htmlFromMd(post.short)"></div>
              <!-- <p v-for="city in post.cities" :key="city" class="dib ml2">
                {{ city }}
              </p> -->
            </div>
          </nuxt-link>
        </div>
      </div>
      <div class="third-line flex">
        <div
          v-for="(post, index) in chunk.slice(3, 6)"
          :key="index"
          :class="{ mr4: index !== 2 }"
          class="w-third ba b--light-silver"
        >
          <nuxt-link
            :to="localePath({ name: 'news-slug', params: { slug: post.slug } })"
            class="no-underline"
          >
            <div class="">
              <img :data-src="post.image" class="lazyload" />
            </div>
            <div class="tl pa4">
              <h3>{{ post.title }}</h3>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div v-html="htmlFromMd(post.short)"></div>
              <!-- <p v-for="city in post.cities" :key="city" class="dib ml2">
                {{ city }}
              </p> -->
            </div>
          </nuxt-link>
        </div>
      </div>
    </div>
    <div class="bg-near-white">
      <DownloadNow />
    </div>
  </div>
</template>

<script>
import marked from 'marked';
import DownloadNow from '~/components/DownloadNow';

function bySix(array) {
  const results = [];
  while (array.length) {
    results.push(array.splice(0, 6));
  }
  return results;
}

export default {
  components: {
    DownloadNow,
  },
  scrollToTop: true,
  async asyncData({ app, $firebaseDb, $sentry }) {
    try {
      const locale = app.i18n.locale;
      const posts = [];
      const postsSnap = await $firebaseDb
        .collection('news')
        .where('language', '==', locale.split('-')[0])
        .where('countries', 'array-contains', locale.split('-')[1])
        .orderBy('date', 'desc')
        .get();
      postsSnap.forEach((post) => {
        const data = post.data();
        posts.push({
          slug: post.id,
          image: data.image,
          category: data.category,
          title: data.title,
          short: data.short,
          cities: data.cities,
          active: data.active,
        });
      });
      return { posts: bySix(posts.filter((p) => p.active)) };
    } catch (error) {
      $sentry.captureException(error);
      throw error;
    }
  },
  data() {
    return {
      posts: [],
    };
  },
  methods: {
    htmlFromMd(text) {
      return marked(text);
    },
  },
};
</script>
